import React from "react"
import * as CookieConsent from "vanilla-cookieconsent"
import "vanilla-cookieconsent/dist/cookieconsent.css"

import { loadGatedScripts } from "src/utils/load-gated-scripts/loadGatedScripts"
import {
  hasGlobalPrivacyControl,
  isConsentManaged,
} from "src/utils/is-consent-managed/isConsentManaged"

import { consentConfig, TRACKING_CATEGORY } from "./consentConfig"

function loadTrackingIfAccepted(): void {
  if (CookieConsent.acceptedCategory(TRACKING_CATEGORY)) loadGatedScripts()
}

export function ConsentManager(): null {
  React.useEffect(() => {
    const gpc = hasGlobalPrivacyControl()

    // Outside the regulated regions, with no opt-out signal, we auto-consent
    // and load immediately — nothing to manage, so no footer controls.
    if (!isConsentManaged()) {
      loadGatedScripts()
      return
    }

    // Initialize the library in every other case. For a Global Privacy Control
    // visitor we suppress the banner (autoShow: false) and pre-decline tracking,
    // but the library still initializes so the footer can reopen preferences and
    // let the visitor override that legally-binding opt-out.
    void CookieConsent.run({
      ...consentConfig,
      autoShow: !gpc,
      onConsent: loadTrackingIfAccepted,
      onChange: loadTrackingIfAccepted,
    })

    // This pre-decline must run synchronously right after the unawaited run():
    // vanilla-cookieconsent v3 defers onConsent/onChange to a microtask, so for
    // a returning visitor with a stale "accepted" cookie this flips tracking off
    // before those callbacks could re-trigger a load. A future library major
    // firing onConsent synchronously inside run() would silently reopen that
    // window, and the Jest mock can't catch it — re-verify against the real
    // library on any vanilla-cookieconsent bump.
    if (gpc) CookieConsent.acceptCategory([], [TRACKING_CATEGORY])
  }, [])

  return null
}
